import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams, CertificateModel } from 'Models'
import { RbidosAccessModel, RbidosAccessAgentModel } from 'Pages/registry_business_access_neo'
import { Callback } from 'Src/types/utilTypes'

export type RbidosAccessState = {
	list: ResponseCatalog<RbidosAccessModel>
	requestParams: RequestParams
	currentRequest: RbidosAccessModel
	newAgent: RbidosAccessAgentModel
	errorPartnerNalogRegDate: boolean
}

export const rbidosAccessInitialState: RbidosAccessState = {
	list: new ResponseCatalog<RbidosAccessModel>(),
	requestParams: new RequestParams(),
	currentRequest: null,
	newAgent: new RbidosAccessAgentModel(),
	errorPartnerNalogRegDate: false,
}

export namespace rbidosAccessNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<RbidosAccessModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type CreateOne = PayloadAction<{
		id: number
		type: string
		callback?: Callback
	}>
	export type GetCurrent = PayloadAction<string>
	export type SetCurrent = PayloadAction<RbidosAccessModel>
	export type GetOne = PayloadAction<{ id: string }>
	export type GetNewAgent = PayloadAction<{ id: string }>
	export type SetNewAgent = PayloadAction<RbidosAccessAgentModel>
	export type UpdateOne = PayloadAction<{
		id: number
		data: RbidosAccessModel
		callback?: Callback
	}>
	export type StatusChange = PayloadAction<{
		id: number
		status: string
		message?: string
		callback?: Callback
	}>
	export type SignDocuments = PayloadAction<
		{ id: number } & (
			| { signatures: Record<string, File> }
			| {
					cert: CertificateModel
					documentsIds: number[]
			  }
		)
	>
	export type SendSignature = PayloadAction<number>
	export type Synchronize = PayloadAction<number>
	export type CheckInfotecsStatus = PayloadAction<number>
	export type SetErrorPartnerNalogRegDate = PayloadAction<boolean>
}

export const rbidosAccessSlice = createSlice({
	name: 'rbidosAccess',
	initialState: rbidosAccessInitialState,
	reducers: {
		getAll: (state, action: rbidosAccessNS.GetAll) => {},
		setAll: (state, action: rbidosAccessNS.SetAll) => {
			state.list = action.payload
		},
		setRequestParams: (state, action: rbidosAccessNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state) => {
			state.list = new ResponseCatalog<RbidosAccessModel>()
			state.requestParams = new RequestParams()
		},
		getOne: (state, action: rbidosAccessNS.GetOne) => {},
		createOne: (state, action: rbidosAccessNS.CreateOne) => {},
		getCurrent: (state, action: rbidosAccessNS.GetCurrent) => {},
		setCurrent: (state, action: rbidosAccessNS.SetCurrent) => {
			state.currentRequest = action.payload
		},
		getNewAgent: (state, action: rbidosAccessNS.GetNewAgent) => {},
		setNewAgent: (state, action: rbidosAccessNS.SetNewAgent) => {
			state.newAgent = action.payload
		},
		updateOne: (state, action: rbidosAccessNS.UpdateOne) => {},
		statusChange: (state, action: rbidosAccessNS.StatusChange) => {},
		signDocuments: (state, action: rbidosAccessNS.SignDocuments) => {},
		sendSignature: (state, action: rbidosAccessNS.SendSignature) => {},
		synchronize: (state, action: rbidosAccessNS.Synchronize) => {},
		checkInfotecsStatus: (state, action: rbidosAccessNS.CheckInfotecsStatus) => {},
		setErrorPartnerNalogRegDate: (state, action: rbidosAccessNS.SetErrorPartnerNalogRegDate) => {
			state.errorPartnerNalogRegDate = action.payload
		},
	},
})
